var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',{staticClass:"chart-component",attrs:{"type":"area","height":"350","options":_vm.chartOptions,"width":_vm.screenWidth,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }